import React from 'react';
import foldStyle from './style';

export default function Title() {
	let style = foldStyle();
	return <h2 style={style.mainTitleTextStyle()}>There’s always room for improvement.</h2>;
}
